import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

export const SUPPORTED_LANGS = ['en', 'ru', 'ee'];

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
  fallbackLng: 'en',
  supportedLngs: SUPPORTED_LANGS,
  detection: {
    order: ['path', 'cookie', 'queryString'],
    lookupFromPathIndex: 0,
    cache: ['cookie']
  },
  interpolation: {
    escapeValue: false
  }
})

export default i18n;